// extracted by mini-css-extract-plugin
module.exports = {"sliderNavigation":"styles_sliderNavigation__1nozZ","browser-ie":"styles_browser-ie__3QpP6","platform-mobile":"styles_platform-mobile__1v-tb"};